import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import Tooltip from 'components/Tooltip';
import { Div, FullWidthDivider } from 'legacyComponents/styled/lib';

import {
  AssignedSeatsInfo,
  TotalSeatsBar,
  BarItem,
  AssignedStats,
  BarKey,
} from 'apps/payment/styles';

export const SeatsBreakdown = withNamespaces()(
  observer(({ paymentSpace }) => {
    if (!paymentSpace) return null;
    const { subscription } = paymentSpace;
    if (!subscription) return null;

    const { seats, spaceType } = subscription;
    const {
      usedSpaceSeats,
      usedProjectsSeats,
      usedInvitesSeats,
      unusedSeats,
      totalSubSeats,
    } = seats;

    const totalUsedSeats =
      usedSpaceSeats + usedProjectsSeats + usedInvitesSeats;

    const totalBarItems = Math.max(totalUsedSeats + unusedSeats, totalSubSeats);

    const assignedBars = [];
    const availableBars = [];
    for (let index = 0; index < totalUsedSeats; index++) {
      assignedBars.push(
        <BarItem
          key={`assigned-${index}`}
          active
          totalBarItems={totalBarItems}
          first={index === 0}
          last={totalUsedSeats === totalBarItems && index + 1 === totalBarItems}
        />,
      );
    }
    // eslint-disable-next-line
    for (let index = 0; index < unusedSeats; index++) {
      availableBars.push(
        <BarItem
          key={`available-${index}`}
          active={false}
          totalBarItems={totalBarItems}
          first={unusedSeats === totalSubSeats && index === 0}
          last={index + 1 === unusedSeats}
        />,
      );
    }

    const assignedToolTip =
      spaceType === 'initiative' ? (
        <Trans>{`Assigned to members of this organisation and it's private projects. Including pending invites.`}</Trans>
      ) : (
        <Trans>
          Assigned to members of your private projects. Including pending
          invites.
        </Trans>
      );

    return (
      <Div width='100%'>
        <FullWidthDivider margin='0px 0px 20px 0px' />
        <AssignedSeatsInfo>
          <b>
            <Trans>Seats Breakdown</Trans>:
          </b>
          <AssignedStats>
            <BarKey active /> {totalUsedSeats} assigned
            <BarKey /> {unusedSeats} available
          </AssignedStats>
        </AssignedSeatsInfo>
        <TotalSeatsBar>
          <Tooltip delayShow={500} />
          <span data-tip={assignedToolTip}>{assignedBars}</span>
          <span
            data-tip={
              <Trans>
                Available to assign to new team members at no extra cost.
              </Trans>
            }
            data-place='bottom'
            data-effect='solid'
            data-delay-show='500'
          >
            {availableBars}
          </span>
        </TotalSeatsBar>
      </Div>
    );
  }),
);

SeatsBreakdown.propTypes = {
  subscription: PropTypes.object,
};
